import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3d4e35fc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "post" }
const _hoisted_2 = ["data-image"]
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "date" }
const _hoisted_5 = { class: "description truncate-2" }

interface Props {
  /** src of image */
  image?: string;
  /** post details */
  date: Date;
  link: string;
  title: string;
  description: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AppPost',
  props: {
    image: null,
    date: null,
    link: null,
    title: null,
    description: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  const _component_AppLink = _resolveComponent("AppLink")!
  const _component_AppFlex = _resolveComponent("AppFlex")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "image",
      "data-image": !!__props.image
    }, [
      _createElementVNode("img", {
        src: __props.image,
        alt: ""
      }, null, 8, _hoisted_3)
    ], 8, _hoisted_2),
    _createVNode(_component_AppFlex, {
      "h-align": "left",
      direction: "col",
      gap: "small",
      class: "text"
    }, {
      default: _withCtx(() => [
        _createElementVNode("span", _hoisted_4, _toDisplayString(__props.date.toLocaleDateString(undefined, {
          day: "numeric",
          month: "long",
          year: "numeric",
        })), 1),
        _createVNode(_component_AppLink, {
          class: "link",
          to: __props.link
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(__props.title), 1)
          ]),
          _: 1
        }, 8, ["to"]),
        _createElementVNode("p", _hoisted_5, _toDisplayString(__props.description), 1)
      ]),
      _: 1
    })
  ]))
}
}

})